import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../../App";
import useFileHandleS3 from "../../../../../CustomHooks/useFileHandleS3";
import useVdieoHandleS3 from "../../../../../CustomHooks/useVideoHandleS3";
import MediaUploadProgressBar from "../../../../../Screen/MediaUploadProgressBar";
import useVideoHandleWithCompress from "../../../../../CustomHooks/useVideoHandleWithCompress";

export default function LearningSessionEdit(props) {
  const { imageCdnUrl , videoCdnUrl} = useContext(serverInfo);
  const history = useHistory();
  const [convertedContent, setConvertedContent] = useState(null);
  const [instruction, setInstruction] = useState(null);
  const [bannerOrVideo, setBannerOrVideo] = useState("0");
  const [starList, setStarList] = useState([]);
  const [loading, setLoading] = useState(false);




  // File Handle
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState("");
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState('');
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'learningSession/images', delKey);
console.log("Delkey is",delKey)



  // Video File Handle
  const videoInputRef = useRef(null);
  const [videoPath, setVideoPath] = useState("");
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'learningSession/videos', videoDelKey);


  const [registerInput, setRegister] = useState({
    id: "",
    title: "",
    slug: "",
    description: "",
    assignment: "",
    type: "",
    star_id: "",
    event_date: "",
    start_time: "",
    end_time: "",
    fee: "",
    participant_number: "",
    registration_start_date: "",
    registration_end_date: "",
    error_list: [],
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
    e.persist();
    setRegister({ ...registerInput, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const event_id = props.match.params.id;

    axios
      .get(`/api/admin/learning_session/details/${event_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setRegister(res.data.event);
          setConvertedContent(res.data.event?.description);
          setInstruction(res.data.event?.instruction);
          if (res.data.event.banner != null) {
            setFilePath(res.data.event.banner);
            setBannerOrVideo("0");
          } else {
            setVideoPath(res.data.event.video);
            setBannerOrVideo("1");
          }
        }
      });

    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.star);
      }
    });
  }, [props.match.params.slug, history]);

  const handleChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };
  const deleteFile = () => {
    setFile('');
    setDelKey(fileKey);
    fileInputRef.current.value = '';

  }

  // Video handle
  const handleChangeVideo = (file) => {
    setVideoDelKey(videoKey);
    setVideo(file[0]);
  };

  const deleteVideo = () => {
    setVideo('');
    setVideoDelKey(videoKey);
    videoInputRef.current.value = '';
  }

  const handleBannerOrVideo = (e) => {
    setBannerOrVideo(e.target.value);
  };

  const registerSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    var banner_or_video = parseInt(bannerOrVideo);
    const fData = new FormData();
    fData.append("banner_or_video", banner_or_video);
    fData.append("image", fileKey ? fileKey : filePath);
    fData.append("video", videoKey ? videoKey: videoPath);
    fData.append("title", registerInput.title);
    fData.append("star_id", registerInput.star_id);
    fData.append("event_date", registerInput.event_date);
    fData.append("start_time", registerInput.start_time);
    fData.append("end_time", registerInput.end_time);
    fData.append("fee", registerInput.fee);
    fData.append("assignment", registerInput.assignment);
    fData.append("participant_number", registerInput.participant_number);
    fData.append(
      "registration_start_date",
      registerInput.registration_start_date
    );
    fData.append("registration_end_date", registerInput.registration_end_date);
    fData.append("description", convertedContent);
    fData.append("instruction", instruction);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/admin/update_learning_session/${registerInput.id}`, fData)
        .then((res) => {
          if (res.data.status === 200) {
            if (file) {
              setFile('');
              setDelKey(filePath)
            }
            if (video) {
              setVideo('');
              setVideoDelKey(videoPath)
            }
            swal("Success", res.data.message, "success");
            history.push("/superstar-admin/learning-session/pending");
          } else {
            setRegister({
              ...registerInput,
              error_list: res.data.errors,
            });
          }
          setLoading(false);
        });
    });
  };

  return (
    <>
      <div className="text-light border border-warning rounded-3 d-flex justify-content-center p-2 my-3">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Edit Learning Session</h4>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  className="p-3"
                  onSubmit={registerSubmit}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text">Select Star</label>
                    <div className="col-sm-9">
                      <select
                        onChange={handleInput}
                        name="star_id"
                        className="form-control reply-control"
                        value={registerInput.star_id}
                      >
                        <option className="text-black" value="">
                          --- Select Star ---
                        </option>

                        {starList.map((user, index) => (
                          <option className="text-black" value={user.id}>
                            {user.first_name} {user.last_name}
                          </option>
                        ))}
                      </select>
                      <small className="text-danger">
                        {registerInput.error_list?.star_id}
                      </small>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Title</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control reply-control"
                        placeholder="write here.."
                        onChange={handleInput}
                        name="title"
                        value={registerInput.title}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.title}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">
                      Select Video Or Banner
                    </label>
                    <div className="col-sm-9">
                      <select
                        onChange={handleBannerOrVideo}
                        name="video_or_banner"
                        className="form-control reply-control"
                        value={bannerOrVideo}
                      >
                        <option className="text-black" value="0">
                          Banner
                        </option>
                        <option className="text-black" value="1">
                          Video
                        </option>
                      </select>
                    </div>
                  </div>

                  {bannerOrVideo === "0" && (
                    <div className="form-group row my-3">
                      <label className="col-sm-3 label-text ">Banner</label>
                      <div className="col-sm-9 file-x-i">
                        {fileUrl && file ? (
                          <div className="position-relative">

                            <img
                              src={fileUrl}
                              className="img-fluid avatar-img-src"
                              alt=""
                              style={{ maxHeight: "300px" }}
                            />
                            <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                          </div>
                        ) : (
                          <img
                            src={imageCdnUrl + filePath}
                            className="img-fluid avatar-img-src"
                            alt=""
                            style={{ maxHeight: "300px" }}
                          />
                        )}

                        <input
                          type="file"
                          accept="image/*"
                          className="form-control reply-control"
                          onChange={(e) => handleChange(e.target.files)}
                          id="image"
                          name="image"
                          ref={fileInputRef}
                        />
                         {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                        <small className="text-danger">
                          {registerInput.error_list?.image}
                        </small>
                      </div>
                    </div>
                  )}
                  {bannerOrVideo === "1" && (
                    <div className="form-group row my-3">
                      <label className="col-sm-3 label-text ">Video</label>
                      <div className="col-sm-9 file-x-i">
                        {videoUrl && video ? (

                          <div className="position-relative">
                            <ReactPlayer
                              url={videoUrl}
                              controls
                              playing={false}
                              volume={1}
                              width="100%"
                              height="200px" // style={{ margin: "0 auto" }}
                            />
                            <span className="text-warning right-cross-button" onClick={deleteVideo}>X</span>
                          </div>


                        ) : <ReactPlayer
                          url={videoCdnUrl + videoPath}
                          controls
                          playing={false}
                          volume={1}
                          width="100%"
                          height="200px" // style={{ margin: "0 auto" }}
                        />}
                        <input
                          type="file"
                          accept="video/*"
                          className="form-control reply-control mb-3"
                          onChange={(e) => handleChangeVideo(e.target.files)}
                          id="video"
                          name="video"
                          ref={videoInputRef}
                        />
                        {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}

                        <small className="text-danger">
                          {registerInput.error_list?.video}
                        </small>
                      </div>
                    </div>
                  )}

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Description</label>
                    <div className="col-sm-9">
                      <CKEditor
                        name="description"
                        data={convertedContent}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setConvertedContent(editor.getData());
                        }}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.description}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Instruction</label>
                    <div className="col-sm-9">
                      <CKEditor
                        name="description"
                        data={instruction}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setInstruction(editor.getData());
                        }}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.instruction}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Event Type</label>
                    <div className="col-sm-5">
                      <select
                        onChange={handleInput}
                        name="assignment"
                        className="form-control reply-control"
                        value={registerInput.assignment}
                      >
                        <option className="text-black" value="">
                          --- Choose One ---
                        </option>
                        <option className="text-black" value="0">
                          Without Assignment
                        </option>
                        <option className="text-black" value="1">
                          With Assignment
                        </option>
                      </select>
                      <small className="text-danger">
                        {registerInput.error_list?.assignment}
                      </small>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Event Date</label>
                    <div className="col-sm-5">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="event_date"
                        value={moment(registerInput.event_date).format(
                          "YYYY-MM-DD"
                        )}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.event_date}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3 text-warning">
                    <label className="col-sm-3 label-text ">Time</label>
                    <div className="col-sm-4">
                      <input
                        type="time"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="start_time"
                        value={registerInput.start_time}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.start_time}
                      </span>
                    </div>{" "}
                    To
                    <div className="col-sm-4">
                      <input
                        type="time"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="end_time"
                        value={registerInput.end_time}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.end_time}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3 text-warning">
                    <label className="col-sm-3 label-text ">
                      Registration Time
                    </label>
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="registration_start_date"
                        value={moment(
                          registerInput.registration_start_date
                        ).format("YYYY-MM-DD")}
                      />
                    </div>{" "}
                    To
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="registration_end_date"
                        value={moment(
                          registerInput.registration_end_date
                        ).format("YYYY-MM-DD")}
                      />
                    </div>
                  </div>

                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">Fee</label>
                    <div className="col-sm-5">
                      <input
                        type="number"
                        className="form-control reply-control"
                        placeholder="0"
                        onChange={handleInput}
                        name="fee"
                        min={0}
                        value={registerInput.fee}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.fee}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">
                      Participant Number
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="number"
                        className="form-control reply-control"
                        placeholder="0"
                        onChange={handleInput}
                        name="participant_number"
                        value={registerInput.participant_number}
                        min={0}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.participant_number}
                      </span>
                    </div>
                  </div>

                  {/* Update Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnUpdate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnUpdate fw-bold" type="submit">
                          Update
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Update Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
